import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Grid from "@mui/material/Grid";
import {dateToHumanDateStr} from "../shared/date.js";
import {Event} from "./Event.jsx";
import {Box, Link} from "@mui/material";
import {Poll} from "./Poll.jsx";

const DanceDay = (props) => {
    const {date, events} = props.danceDay;
    const dstr = dateToHumanDateStr(new Date(props.danceDay.date + "T12:00:00"));

    const venues = [...new Map(events.map(e => [e.venue.venueKey, {venueKey: e.venue.venueKey, venueName: e.venue.name}])).values()];

    let stickyAt = "170px"
    if (window.innerWidth < 600) {
        stickyAt = "100px"
    }

    return (
        <div>
        {/*<div style={{position: "sticky", top: stickyAt, height: "50px",background: "linear-gradient(180deg,rgba(58, 52, 54, 1) 0%, rgba(58, 52, 54, 1) 60%, rgba(58, 52, 54, 0) 100%)", zIndex:1}}>*/}
            <Box p={1} style={{position: "sticky", top: stickyAt, backgroundColor: "#3A3436", zIndex:1}}>

                <Link style={{float: "right"}} href={"/calendar/" + date}>Detailed Calendar</Link>
                {dstr}
            </Box>
            <Card variant={"outlined"}>
                <CardContent>
                    <Box m={1} mb={3 }sx={{display: "flex", justifyContent: "center"}}><Poll date={date} venues={venues} /></Box>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                        {events.slice(0, Math.ceil(events.length / 2)).map((event, i) =>
                            <div key={i}>
                                <Event event={event} />
                            </div>
                        )}
                        </Grid>
                        <Grid item xs={12} sm={6}>
                        {events.slice(Math.ceil(events.length / 2), events.length).map((event, i) =>
                            <div key={i}>
                                <Event event={event}/>
                            </div>
                        )}
                        </Grid>
                    </Grid>

                </CardContent>
            </Card>
        </div>
    );
}

export default DanceDay;